import React from 'react';
import { useForm } from '@inertiajs/react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

interface FileItem {
    id: number;
    name: string;
}

interface RenameFileDialogProps {
    file: FileItem;
    onClose: () => void;
}

export default function RenameFileDialog({ file, onClose }: RenameFileDialogProps) {
    const { data, setData, patch, processing, errors } = useForm({
        name: file.name,
    });

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        patch(`/uploaded_files/${file.id}`, {
            onSuccess: () => {
                onClose();
            },
        });
    };

    return (
        <Dialog open={true} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Rename File</DialogTitle>
                    <DialogDescription>
                        Enter a new name for "{file.name}"
                    </DialogDescription>
                </DialogHeader>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-2">
                        <Label htmlFor="name">File Name</Label>
                        <Input
                            id="name"
                            value={data.name}
                            onChange={(e) => setData('name', e.target.value)}
                            autoFocus
                        />
                        {errors.name && (
                            <p className="text-sm text-destructive">{errors.name}</p>
                        )}
                    </div>

                    <div className="flex justify-end gap-2">
                        <Button type="button" variant="outline" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button type="submit" disabled={processing || !data.name}>
                            {processing ? 'Renaming...' : 'Rename'}
                        </Button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
}